export enum API_CODES {
  SUCCESS = 0,
  // 服务器开小差了，请稍后再试~
  UNDIFINED_ERROR = 9999,
  // 未登录
  NOT_LOG_IN = 900010000,

  // 校验次数过多，请进行安全校验
  CAPTCHA_VERFIY_FAIL = 900120003,
}

export const RequestBaseUrlMap: Record<string, string> = {
  dev: 'https://api-fat.meilisci.com',
  fat: 'https://api-fat.meilisci.com',
  uat: 'https://api-uat.meilisci.com',
  prod: 'https://api.meilisci.com',
};
